import React from 'react';
import GreyLogo from '@/assets/svgs/grey-logo.svg';
import VerticalLine from '@/assets/svgs/vertical-line.svg';
import { HStack, VStack } from '@airwallex/stacks';
import { useTranslation } from 'react-i18next';
import { Text } from '@airwallex/typography';
import { space } from '@airwallex/global';
import { grays } from '@airwallex/colors';
import LanguageSelect from './LanguageSelect';
import { useTabletOrMobile } from '@/hooks/useMediaQueryV2';

const Terms = (): React.ReactElement => {
  const { t } = useTranslation();
  const isTabletOrMobile = useTabletOrMobile();
  return (
    <VStack align="CENTER">
      <HStack space={space.s} align="CENTER" style={{ alignItems: 'center' }}>
        <HStack space={space.xs} align="CENTER" style={{ alignItems: 'center' }}>
          <Text
            variant="hint"
            color="secondary"
            style={{ cursor: 'pointer', color: grays[60] }}
            onClick={() => {
              window.open(
                'https://www.airwallex.com/au/terms/privacy-policy#scope-of-policy',
                '_blank',
                'noopener,noreferrer'
              );
            }}
          >
            {t('terms')}
          </Text>
          <Text variant="hint" color="secondary">
            ·
          </Text>
          <Text
            variant="hint"
            color="secondary"
            style={{ cursor: 'pointer', color: grays[60] }}
            onClick={() => {
              window.open(
                'https://www.airwallex.com/au/terms/privacy-policy#scope-of-policy',
                '_blank',
                'noopener,noreferrer'
              );
            }}
          >
            {t('privacy')}
          </Text>
        </HStack>
        <VerticalLine />
        <LanguageSelect />
      </HStack>
      <HStack
        space={isTabletOrMobile ? '10px' : '26px'}
        align="CENTER"
        style={{ alignItems: 'center', paddingBottom: space.xl }}
      >
        <HStack space="4px" style={{ alignItems: 'center', marginRight: 16 }}>
          <Text variant="hint" color="secondary">
            {t('poweredBy')}
          </Text>
          <GreyLogo />
        </HStack>
      </HStack>
    </VStack>
  );
};

export default Terms;
